"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Existence = void 0;
const types_1 = require("@comunica/types");
class Existence {
    constructor(expression) {
        this.expression = expression;
        this.expressionType = types_1.ExpressionType.Existence;
    }
}
exports.Existence = Existence;
//# sourceMappingURL=Existence.js.map